import { APP_CONSTANTS } from 'src/app/constants/constants';
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { environment } from 'src/environments/environment';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-initiative-management',
  templateUrl: './initiative-management.component.html',
  styleUrls: ['./initiative-management.component.scss'],
})
export class InitiativeManagementComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

  @Input() filters_data: any;
  user_details: any;

  constructor(
    public commonService: CommonService,
    private storageService: StorageService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.user_details = this.storageService.get('user_details');
    // this.getBusinessPlans();
    this.getInitiativesData();
    this.getStatus();
  }

  filterChange(data) {
    this.filters_data = data;
    this.getInitiativesData();
  }

  business_plan: any = '';
  business_plan_list: any = [];
  getBusinessPlans() {
    this.initiative_data_loaded = false;
    const financial_institution = this.user_details.financial_institution;
    this.commonService.getData('/businessPlan?no_page=true&financial_institution=' + financial_institution + '/').subscribe(
      (res: any) => {
        this.business_plan_list = res;
        if (this.business_plan_list.length > 0) {
          this.business_plan = this.business_plan_list[0].id;
          this.getInitiativesData();
        } else {
          this.initiative_data_loaded = true;
        }
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  status_list: any = [];
  getStatus() {
    this.commonService.getData('/status?no_page=true').subscribe(
      (res: any) => {
        this.status_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  initiative_data: any = [];
  initiative_data_loaded: boolean = false;
  getInitiativesData() {
    this.show_mile_stones = null;
    this.initiative_data_loaded = false;
    // this.commonService.getData("/initiativemanagement?business_plan_id=" + this.business_plan).subscribe(
    this.commonService
      .getData(
        '/initiativemanagement?business_plan_id=' +
          this.filters_data.business_plan,
      )
      .subscribe(
        (res: any) => {
          this.initiative_data = res;
          this.initiative_data_loaded = true;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
          this.initiative_data_loaded = true;
        },
      );
  }


  page_current_page: any = 1;
  pageChanged(event) {
    this.show_mile_stones = null;
    this.page_current_page = event;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
  }

  selected_initiative_data: any = {
    initiative_status: '',
    initiative_roi: '',
  };
  selected_initiative_data_errors: any = {
    initiative_status: false,
    initiative_roi: false,
  };
  selected_initiative_index: any = null;

  @ViewChild('initiativeOperationsModal')
  initiativeOperationsModal: TemplateRef<any>;
  private initiativeOperationsModalRef: MatDialogRef<TemplateRef<any>>;
  openInitiativeOperationsModal(data, index) {
    this.selected_initiative_data = JSON.parse(JSON.stringify(data));
    this.selected_initiative_index = index;
    this.initiativeOperationsModalRef = this.dialog.open(
      this.initiativeOperationsModal,
      { disableClose: true },
    );
    this.initiativeOperationsModalRef.afterClosed().subscribe((result) => {
      this.closeInitiativeOperationsModal();
    });
  }

  closeInitiativeOperationsModal() {
    this.initiativeOperationsModalRef.close();
    this.selected_initiative_data = {
      initiative_status: '',
      initiative_roi: '',
    };
    this.selected_initiative_data_errors = {
      initiative_status: false,
      initiative_roi: false,
    };
    this.selected_initiative_index = null;
  }

  saveInitiative() {
    // if (this.selected_initiative_data.initiative_roi != "" && this.selected_initiative_data.initiative_roi != null) {
    // 	this.selected_initiative_data_errors.initiative_roi = false;
    // } else {
    // 	this.selected_initiative_data_errors.initiative_roi = true;
    // }

    if (
      this.selected_initiative_data.initiative_status != '' &&
      this.selected_initiative_data.initiative_status != null
    ) {
      this.selected_initiative_data_errors.initiative_status = false;
    } else {
      this.selected_initiative_data_errors.initiative_status = true;
    }

    if (
      // this.selected_initiative_data_errors.initiative_roi == false &&
      this.selected_initiative_data_errors.initiative_status == false
    ) {
      const payload = {
        initiative_status: this.selected_initiative_data.initiative_status,
        initiative_roi: this.selected_initiative_data.initiative_roi,
      };
      this.commonService
        .patch(
          '/businessPlanInitiative/' +
            this.selected_initiative_data.initiative_id,
          payload,
        )
        .subscribe(
          (res: any) => {
            this.initiative_data.splice(this.selected_initiative_index, 1, res);
            this.commonService.showToast(
              'success',
              'Initiative Updated Successfully.',
            );
            this.closeInitiativeOperationsModal();
          },
          (err) => {
            this.commonService.showToast('error', err.error);
          },
        );
    }
  }

  uploadInitiative(event, initiative, index) {
    const formData: FormData = new FormData();
    formData.append('initiative_attachment', event.target.files[0]);
    formData.append('initiative_id', initiative.initiative_id);
    this.commonService
      .patch(
        '/businessPlanInitiative/' + initiative.initiative_id + '/',
        formData,
      )
      .subscribe(
        (res: any) => {
          this.initiative_data.splice(index, 1, res);
          this.commonService.showToast(
            'success',
            'Initiative Document Uploaded Successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  downloadInitiativeAttachment(link) {
    window.open(environment.apiEndpoint + '/' + link, '_blank');
  }

  show_mile_stones: number = null;
  toggleMileStonesView(value) {
    if (this.show_mile_stones == value) {
      this.show_mile_stones = null;
    } else {
      this.show_mile_stones = value;
    }
  }
}
